import * as React from 'react';
import WorkflowTrigger from './WorkflowTrigger';
import {
  IWorkflowStep,
  IWorkflowTrigger,
  IWorkflowCondition,
  IWorkflowExecute,
  IWorkflowQueue,
} from './business-objects/common';
import {
  Form,
  Tabs,
  Tab,
  Row,
  Col,
  Accordion,
  Card,
} from 'react-bootstrap';
import SelectList from '../RBSelectList/RBSelectList';
import { FormIOFormResponse, listForms } from '../../services/formIOService';

export interface IWorkflowStepProps {
  step: IWorkflowStep;
  steps: IWorkflowStep[];
  queues: IWorkflowQueue[];
  forms: { name: string, value: string }[];
  handleStepChange: (e: React.FormEvent, stepId: number) => void;
  handleTriggerChange: (e: React.FormEvent, trigger: IWorkflowTrigger) => void;
  handleConditionChange: (
    e: React.FormEvent,
    condition: IWorkflowCondition,
    dataField: string
  ) => void;
  handleExecuteChange: (
    e: React.FormEvent,
    execute: IWorkflowExecute,
    dataField: string
  ) => void;
  addTrigger: (step: IWorkflowStep) => void;
  addCondition: (trigger: IWorkflowTrigger) => void;
  addExecute: (trigger: IWorkflowTrigger) => void;
  removeStep: (id: number) => void;
  removeTrigger: (id: number) => void;
  removeTriggerCondition: (id: number) => void;
  removeTriggerExecute: (id: number) => void;
}

export default class WorkflowStep extends React.Component<IWorkflowStepProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    return (
      <React.Fragment>
        <i
          title='Remove Step'
          className='fas  fa-ban fa-lg pointer float-right'
          onClick={(e) => this.props.removeStep(this.props.step.id)}
        ></i>
        <Form>
          <Row>
            <Col>
              <Form.Group controlId='Name'>
                <Form.Label>
                  <strong>Step Name</strong>
                </Form.Label>
                <Form.Control
                  type='text'
                  data-field='name'
                  placeholder='Step Name'
                  onChange={(e) =>
                    this.props.handleStepChange(e, this.props.step.id)
                  }
                  value={this.props.step != null ? this.props.step.name : ''}
                />
              </Form.Group>
              <Form.Group>
                <Form.Check
                  key={`chk-HasHoldOnComplete-${this.props.step.id}`}
                  id={`chk-HasHoldOnComplete-${this.props.step.id}`}
                  type='checkbox'
                  label='Use Hold Queue'
                  data-field='hasHoldOnComplete'
                  data-reqid={this.props.step.id}
                  checked={this.props.step.hasHoldOnComplete}
                  onChange={(e) =>
                    this.props.handleStepChange(e, this.props.step.id)
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId='StepNumber'>
                <Form.Label>
                  <strong>Step Number</strong>
                </Form.Label>
                <Form.Control
                  // id={'stepNumber' + this.props.step.id.toString()}
                  type='number'
                  data-field='stepnumber'
                  placeholder='Step Name'
                  onChange={(e) =>
                    this.props.handleStepChange(e, this.props.step.id)
                  }
                  value={
                    this.props.step != null
                      ? this.props.step.stepNumber.toString()
                      : ''
                  }
                />
              </Form.Group>
            </Col>            
            <Col>
              <Form.Group controlId='RequiredSteps'>
                <Form.Label>
                  <strong>Workflow Queues</strong>
                </Form.Label>
                <Accordion defaultActiveKey='0'>
                  <Card key='workflowQueueCard' className='workflowQueueCard'>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey='workflowQueue'
                      key='workflowQueue'
                      className='accordianHeader'
                    >
                      Queues where this step will appear{' '}
                      <i
                        title='Remove Trigger'
                        className='fas fa-plus-square pointer float-right'
                      ></i>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey='workflowQueue'>
                      <Card.Body>
                        {this.props.queues.map((q) => (
                          <Form.Check
                            key={`chk-queue-${this.props.step.id}-${q.id}`}
                            id={`chk-queue-${this.props.step.id}-${q.id}`}
                            type='checkbox'
                            label={q.description}
                            data-field='workflowQueue'
                            data-queueid={q.id}
                            checked={
                              this.props.step.workflowStepQueues &&
                              this.props.step.workflowStepQueues.some(
                                (x) =>
                                  x.workflowStepId == this.props.step.id &&
                                  x.workflowQueueId == q.id
                              )
                            }
                            onChange={(e) =>
                              this.props.handleStepChange(e, this.props.step.id)
                            }
                          />
                        ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>
                  <strong>FormIO Form</strong>
                </Form.Label>
                <SelectList
                  data={this.props.forms}
                  value={this.props.step.formIoFormId}
                  datafield='formIoFormId'
                  onChange={(e) => this.props.handleStepChange(e, this.props.step.id)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <div className='divTriggerContainer'>
          <h3>
            {this.props.step.name} Triggers&nbsp;&nbsp;
            <i
              title='Add Trigger'
              className='fas fa-plus-square pointer'
              onClick={(e) => this.props.addTrigger(this.props.step)}
            ></i>
          </h3>

          {this.props.step &&
            this.props.step.triggers &&
            this.props.step.triggers.length > 0 && (
              <div className='workflowtriggers'>
                <Tabs
                  defaultActiveKey={this.props.step.triggers[0].id}
                  id='trigger-tabs'
                >
                  {this.props.step.triggers.map((trigger, index) => {
                    return (
                      <Tab
                        eventKey={trigger.id.toString()}
                        title={trigger.name}
                        key={trigger.id}
                      >
                        <WorkflowTrigger
                          key={trigger.id}
                          steps={this.props.steps}
                          trigger={trigger}
                          addCondition={this.props.addCondition}
                          addExecute={this.props.addExecute}
                          handleTriggerChange={this.props.handleTriggerChange}
                          handleConditionChange={
                            this.props.handleConditionChange
                          }
                          handleExecuteChange={this.props.handleExecuteChange}
                          removeTrigger={this.props.removeTrigger}
                          removeTriggerCondition={
                            this.props.removeTriggerCondition
                          }
                          removeTriggerExecute={this.props.removeTriggerExecute}
                        />
                      </Tab>
                    );
                  })}
                </Tabs>
              </div>
            )}
        </div>
      </React.Fragment>
    );
  }
}
